module.exports = "<svg id=\"96d3809c-b62b-46f3-b5a4-baf071cc90d3\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><path d=\"M25,.22A16.59,16.59,0,0,0,8,17.08a19.73,19.73,0,0,0,1.39,6.31C14.15,33.65,17.86,39.49,25,49.78,32.23,39,36.24,33.56,41,23.38a19.36,19.36,0,0,0,1-6.31A16.65,16.65,0,0,0,25,.22Zm-.12,27.3a10.3,10.3,0,1,1,10.21-10.3A10.26,10.26,0,0,1,24.85,27.52Z\" style=\"fill:#d67773\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = UqX2
// module chunks = 11